import { createActions } from 'redux-actions';

export default createActions({
  MYPAGE: {
    MYEVENTS: {
      SET: (eventType) => ({
        eventType,
      }),
      SUCCESS: (data) => ({
        data,
      }),
      FAILURE: (error) => ({
        error,
      }),
      CHANGETYPE: (eventType) => ({
        eventType,
      }),
    },
  },
});
